<template>
  <div class="content">
    <ModalCobrancaTransacaoNaoAutorizada
      :transacao="transaction"
      :showModal="showModal"
      :creditCardValid="false"
      @btnNao="showModal = false"
      @btnSim="cobrarTransacao"
    />
    <ModalUpdatePendingPaymentWithPixVue
      :showModalPaymentWithPix="showModalPaymentWithPix"
      :transactionId="transactionId"
      @disagree="showModalPaymentWithPix = false"
      @agree="updatePendingWithPix"
    />

    <BlockUI
      v-if="blockScreen"
      :message="blockScreenData.msg"
      :url="blockScreenData.url"
    />

    <v-card>
      <v-card-title>
        Pagamentos não autorizados
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md6 sm6>
              <v-col align="start">
                <v-text-field
                  v-model="search"
                  prepend-icon="search"
                  label="Procurar"
                  single-line
                  hide-details
                />
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="pendingTransation"
          :search="search"
          class="elevation-1 mt-2"
          no-data-text="Nenhuma pagamento não autorizado registrado"
          :footer-props="{
            'items-per-page-text': 'Linhas por página:',
          }"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>
                {{ item.id }}
              </td>
              <td>{{ item.vehicle_request_id }}</td>
              <td>{{ item.user.name }}</td>
              <td>R$ {{ item.total_value_charged | formatPrice }}</td>
              <td>{{ item.pre_authorization_date | formatData }}</td>
              <td>{{ item.status | formatStatus }}</td>
              <td>
                <ActionButton
                  message="Cobrar"
                  icon="mdi-credit-card-plus"
                  color="success"
                  @onclick="openModalCobranca(item)"
                />
                <ActionButton
                  message="Atualizar pendência paga via PIX"
                  icon="mdi-data-matrix-plus"
                  color="alert"
                  @onclick="openModalPaymentWithPix(item)"
                />
                <ActionButton
                  message="Detalhes da reserva"
                  icon="open_in_new"
                  color="info"
                  @onclick="detail(item)"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import TransactionController from '../../controllers/TransactionController';
import ModalCobrancaTransacaoNaoAutorizada from '../shared/ModalCobrancaTransacaoNaoAutorizada.vue';
import ModalUpdatePendingPaymentWithPixVue from '../shared/ModalUpdatePendingPaymentWithPix.vue';
import ActionButton from '../shared/ActionButtonsTemplate';
import NumberHelper from './../../helpers/NumberHelper';
import moment from 'moment';

export default {
  created() {
    this.report();
  },
  components: {
    ActionButton,
    ModalCobrancaTransacaoNaoAutorizada,
    ModalUpdatePendingPaymentWithPixVue,
  },
  data() {
    return {
      transactionController: new TransactionController(this.$resource),
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      search: '',
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Reserva_id', value: 'vehicle_request_id' },
        { text: 'Usuário', value: 'user.name' },
        { text: 'Valor total', value: 'total_value_charged' },
        { text: 'Data de cobrança', value: 'pre_authorization_date' },
        { text: 'Status', value: 'status' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
      pendingTransation: [],
      transaction: {},
      transactionId: null,
      showModal: false,
      showModalPaymentWithPix: false,
    };
  },
  methods: {
    report() {
      this.transactionController.getPendingTransactions().then(res => {
        this.pendingTransation = res;
      });
    },
    openModalPaymentWithPix(transaction) {
      this.transactionId = transaction.id;
      this.showModalPaymentWithPix = true;
    },

    openModalCobranca(item) {
      this.transaction = item;
      this.showModal = true;
    },
    cobrarTransacao(value) {
      this.blockScreen = true;
      this.transactionController
        .captureTransaction({
          id: this.transaction.id,
          credit_card_id: value.creditCardId,
          installments: value.installments,
        })
        .then(res => {
          this.$awn.success('Cobrança realizada com sucesso!');
          this.showModal = false;
        })
        .catch(error => {
          this.$awn.alert(error.data.message);
        })
        .finally(() => {
          this.blockScreen = false;
        });
    },

    async updatePendingWithPix(data) {
      try {
        const res = await this.transactionController.updatePendingTransactionsPaidWithPIX(
          data.id,
          {
            description: data.description,
            capture_date: data.capture_date,
          }
        );
        this.showModalPaymentWithPix = false;

        res.ok === false
          ? this.$awn.alert(res.message)
          : this.$awn.success(res.message);

        this.report();
      } catch (error) {
        this.$awn.alert(error.message);
      }
    },

    detail(item) {
      let routeData = this.$router.resolve({
        name: 'tcs-vehicle-request-detail',
        params: {
          id: item.vehicle_request_id,
        },
      });
      window.open(routeData.href, '_blank');
      localStorage.setItem('pageBack', Constants.ROUTER_NAME_SERVICE);
    },
  },
  filters: {
    formatPrice(price) {
      return NumberHelper.formatPrice(price);
    },
    formatData(value) {
      return moment(value).format('DD[/]MM[/]YYYY');
    },
    formatStatus(value) {
      return value == 'pending' ? 'Pendente' : 'Não autorizado';
    },
  },
};
</script>
<style lang="scss">
.radios {
  margin: 5px;
}
.radios input {
  margin-right: 3px;
}
.radios label {
  margin-right: 15px;
}
.table-custom-vue {
  margin: 20px;
}
.table-custom-vue td:last-child {
  display: flex;
  justify-content: center;
}
.table-custom-vue thead tr > th,
.table-custom-vue tbody td {
  text-align: center !important;
}

.import-driver-button,
.new-driver-button {
  border: none;
  &:hover {
    background: var(--primary-color-hover);
  }
}
.card-header .filter-header {
  background: var(--secondary-color) !important;
}

.import-driver-button,
.new-driver-button {
  border: none;
  &:hover {
    color: white;
    background: var(--primary-color-hover);
  }
}
</style>
